/* istanbul ignore file */
export enum NumberFormatOptions {
    Number = 'number',
    USDollar = 'usDollar',
    Percent = 'percent',
    Duration = 'duration',
    Hours = 'hours',
    Date = 'date'
}

export enum NumberFormatFieldNames {
    Format = 'format',
    DecimalPlaces = 'decimalPlaces'
}
